export class Swipe {
  private readonly left: (event: TouchEvent) => void
  private readonly right: (event: TouchEvent) => void
  private start = 0
  private end = 0
  //this sets the minimum swipe distance, to avoid noise and to filter actual swipes from just moving fingers
  private readonly treshold: number = 100
  private readonly touchStartHandler = this.onTouchStart.bind(this)
  private readonly touchEndHandler = this.onTouchEnd.bind(this)

  // TODO: I think callback methods shouldn't be passed from constructor. Can be passed only the time
  // when we actually signed up for event listeners
  constructor(left: (event: TouchEvent) => void, right: (event: TouchEvent) => void) {
    this.left = left
    this.right = right
  }

  handleTouch(event: TouchEvent) {
    const xDist = this.end - this.start
    if (xDist > -this.treshold && xDist < this.treshold) return

    if (this.end - this.start < 0) {
      this.left(event)
    } else {
      this.right(event)
    }
  }

  onTouchStart(event: TouchEvent) {
    this.start = event.touches[0].clientX
  }

  onTouchEnd(event: TouchEvent) {
    this.end = event.changedTouches[0].clientX
    this.handleTouch(event)
  }

  addEventListener() {
    window.addEventListener("touchstart", this.touchStartHandler)
    window.addEventListener("touchend", this.touchEndHandler)
  }

  clear() {
    window.removeEventListener("touchstart", this.touchStartHandler)
    window.removeEventListener("touchend", this.touchEndHandler)
  }
}
